import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

function getStyles(name, optionName, theme) {
	return {
		fontWeight: optionName?.includes(name)
			? theme.typography.fontWeightMedium
			: theme.typography.fontWeightRegular,
	};
}

export default function MultiSelectDropDown(props) {
	const theme = useTheme();

	const handleChange = (event) => {
		const {
			target: { value },
		} = event;
		props.setOptionName(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};

	return (
		<div>
			<FormControl
				sx={{
					width: 280,
					".MuiInputLabel-root": { fontSize: "0.9rem" },
				}}
			>
				<InputLabel id="demo-multiple-chip-label">{props.label}</InputLabel>
				<Select
					labelId="demo-multiple-chip-label"
					id="demo-multiple-chip"
					multiple
					value={props.optionName}
					onChange={handleChange}
					disabled={props.disabled}
					input={
						<OutlinedInput id="select-multiple-chip" label={props.label} />
					}
					renderValue={(selected) => (
						<Box
							sx={{
								display: "flex",
								flexWrap: "wrap",
								gap: 0.5,
								maxHeight: "75px",
								overflowY: "auto",
								scrollbarWidth: "none",
							}}
						>
							{selected.map((value) => (
								<Chip key={value} label={value} />
							))}
						</Box>
					)}
					MenuProps={MenuProps}
				>
					{props.list.map((item) => {
						const displayName = item.name || item.leaderName;

						return (
							<MenuItem
								key={displayName}
								value={displayName}
								style={getStyles(displayName, props.optionName, theme)}
							>
								{displayName}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
}
